import Settings from 'settings'

export const page = {
  name: 'page',
  request: {
    url: `${Settings.api}/pages/?slug=:id`,
    middleware: {
      checkStore: store => store.location.payload.id === store.page.data[0].slug
    }
  },
  state: {
    data: [{
      slug: null,
      title: {rendered: null},
      content: {rendered: null},
      acf: {},
    }] // page needs an empty array, so we override default 'data' here
  },
}



// WEBPACK FOOTER //
// ./src/redux/models/page.js